import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';

const CountriesList = () => {
  const countries = window.__litium.countriesList;
  const linkRefs = useRef([]);

  const handleKeyNavigation = (e, index) => {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      const next = (index + 1) % countries.length;
      linkRefs.current[next]?.focus();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      const prev = (index - 1 + countries.length) % countries.length;
      linkRefs.current[prev]?.focus();
    } else if (e.key === 'Enter') {
      // valfritt: låt länken aktiveras manuellt
      e.preventDefault();
      linkRefs.current[index]?.click();
    }
  };

  return (
    <Fragment>
      {countries && countries.length > 0 && (
        <details>
          <summary>{translate('header.changecountry')}</summary>
          <div className="header__changecountry--countries">
            {countries.map((country, index) => (
              <a
                key={'countries-a' + index}
                href={country.countryURL}
                title={country.countryName}
                ref={(el) => (linkRefs.current[index] = el)}
                tabIndex={0}
                onKeyDown={(e) => handleKeyNavigation(e, index)}
              >
                {country.countryName}
              </a>
            ))}
          </div>
        </details>
      )}
    </Fragment>
  );
};

export default CountriesList;
